import { WithHeaderFromPreviousDesignSystem } from './WithHeaderFromPreviousDesignSystem';
import { WithHeaderInternal } from './WithHeaderInternal';

export const Wrapper = {
  WithHeaderFromPreviousDesignSystem,
  WithHeaderInternal,
}
